import Modal from '@components/v2/ui/Modal/Modal';
import LangEnum from '../../../lang/LangEnum';
import { useTranslation } from '../../translation/TranslationContext';

interface BackToDraftModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const BackToDraftModal = ({ onClose, open, onConfirm }: BackToDraftModalProps) => {
  const { translate } = useTranslation();

  return (
    <Modal
      isOpen={open}
      size="standard"
      header={{ title: LangEnum.ORDER_SUMMARY_BACK_TO_DRAFT_ACTION_LABEL }}
      onClose={onClose}
      footer={{
        primaryAction: { label: LangEnum.GLOBAL_CONTINUE, onClick: onConfirm },
        secondaryAction: { label: LangEnum.GLOBAL_CANCEL_LABEL, onClick: onClose },
      }}
    >
      {translate(LangEnum.ORDER_BACK_TO_DRAFT_MODAL_TEXT)}
    </Modal>
  );
};

export default BackToDraftModal;
